import { gql } from '@apollo/client'

export const UPDATE_ACTIVITY_LAST_READ = gql`
  mutation UpdateActivityLastRead($input: UpdateActivityLastReadInput!) {
    updateActivityLastRead(input: $input) {
      fantasyLeagueMember {
        id
        activityLastReadAt
        unreadActivityCount
      }
      errors
    }
  }
`
